import { render, staticRenderFns } from "./detail_marketplace_page.vue?vue&type=template&id=446ea665&scoped=true"
import script from "./detail_marketplace_page.vue?vue&type=script&lang=js"
export * from "./detail_marketplace_page.vue?vue&type=script&lang=js"
import style0 from "./detail_marketplace_page.vue?vue&type=style&index=0&id=446ea665&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446ea665",
  null
  
)

export default component.exports